<template>
  <div>
    <router-link to="/">
    <h1 :class="status === 'page' ? 'prjPage' : ''">
      <!-- <span id="girelli">OUT/OF</span><br />
      <span id="sofia">Office</span> -->
      <span id="title__top">OUT/OF</span><br />
      <span id="title__bottom">Office</span>
    </h1>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    status: String,
  },
};
</script>

<style lang="scss" scoped>
h1 {
  color: white;
  font-weight: normal;
  padding: 43px 0 0 0;
  margin-left: 38px;
  display: inline-block;
  // font-size: 10.4vw;
  font-size: 7.8vw;
  line-height: 85%;
  @media screen and (max-width: 767px) {
    margin-left: 20px;
    padding-top: 20px;
    font-size: 8.4vh;
  }
  transition: 600ms ease-out;
  &:hover{
    filter: blur(5px);
  }
}
#sofia {
  font-family: SangBleuEmpire;
}

#girelli {
  font-family: Newake;
  font-size: 7.1vw;
}

#title__top{
  font-family: Newake;
  font-size: 7.1vw;
  @media screen and (max-width: 767px) {
    font-size: 7.6vh;
  }
}

#title__bottom{
  font-family: SangBleuEmpire;
}

.prjPage{
  position: absolute;
  font-size: calc(7.8vw / 2);
    #title__top{
    font-size: calc(7.1vw / 2);
  }
  @media screen and (max-width: 767px) {
    position: static;
    font-size: calc(8.4vh / 2);
    #title__top{
      font-size: calc(7.6vh / 2);
    }
  }

}
</style>
